module.exports = __webpack_public_path__ + "img/hero-banner.85194ab.jpg";